class TabelaItemController extends AbstractController
  @$inject = ['$injector', '$scope', 'pathService', 'atividadeService', 'tabelaItemService']

  Alert = null
  Confirm = null

  constructor: ($injector, scope, pathService, @atividadeService, @tabelaItemService) ->
    super($injector)

    Alert = @Alert
    Confirm = @Confirm

    @tabela = scope.tabData.tabela

    @loadingTracker = @promiseTracker()

    @modalTabela = @openPopup("#{pathService.getViewUrl()}/eficiencia-fiscal/view/configuracao/tabelas-sped/tabela-itens/modal.html", 'tabelaItemModalController as ctrl')
    @modalImportar = @openPopup("#{pathService.getViewUrl()}/eficiencia-fiscal/view/configuracao/tabelas-sped/tabela-itens/importar.html", 'tabelaItemImportModalController as ctrl', 'lg', 'static')
    @modalImportarLegislacao = @openPopup("#{pathService.getViewUrl()}/eficiencia-fiscal/view/configuracao/tabelas-sped/tabela-itens/importar-legislacao.html", 'tabelaImportarLegislacaoModalController as ctrl', 'lg', 'static')

    @filtro =
      tabela: @tabela
      page: 1
      estado: ''

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @loadItens()

  loadItens: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page
    @loadingTracker.addPromise @tabelaItemService.search(filtro, (data) =>
      if data.success
        @listOfTabelaItem = data.data.items

        @pagination.page = page
        @pagination.totalPages = data.data.totalPages
    )

    @loadingTracker.addPromise @atividadeService.getList((data) =>
      @listOfAtividade = data
    )

  editar: (item) ->
    @modalTabela({
      item: -> item,
      atividades: => @listOfAtividade
    }, (result) =>
      @loadItens() if result.ok
    )

  add: ->
    @modalTabela({
      item: => {
        tabela: @tabela
        manual: true
      },
      atividades: => @listOfAtividade
    }, (result) =>
      @loadItens() if result.ok
    )

  clonar: (item) ->
    item = angular.copy item
    item.ncms = item.ncms.map((ncm)-> ncm.id) if item.ncms
    item.ncmExcecoes = item.ncmExcecoes.map((ncm)-> ncm.id) if item.ncmExcecoes
    item.id = null
    @modalTabela({
      item: => item,
      atividades: => @listOfAtividade
    }, (result) =>
      @loadItens() if result.ok
    )

  importar: ->
    @modalImportar({tabela: => @tabela}, (result) =>
      @loadItens()
    )

  importarLegislacao: ->
    @modalImportarLegislacao({tabela: => @tabela}, (result) =>
      @loadItens()
    )

  remover: (item)->
    Confirm.warning('Atenção', "Deseja realmente remover o item da tabela ##{item.codigo} - #{item.descricaoProduto}?", {
      Sim: =>
        @tabelaItemService.delete(item.id, (result)=>
          if(result.success)
            Alert.success("O item ##{item.codigo} - #{item.descricaoProduto} foi removido!.", 'Sucesso')
            @loadItens()
          else
            Alert.error("Ocorreu um erro ao remover o item #{item.codigo} - #{item.descricaoProduto}.")
        )
      Não: ''
    })  


angular.module("eficienciaFiscalModule").controller("tabelaItemController", TabelaItemController)


class TabelaItemModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'tabelaItemService', 'eflService', 'atividades', 'item']

  Alert = null

  constructor: ($injector, @modalInstance, @tabelaItemService, @eflService, @atividades, item) ->
    super($injector)

    Alert = @Alert

    @loadingTracker = @promiseTracker()
    @submitTracker = @promiseTracker()

    @tabela = item.tabela
    @item = item

    if item.id
      @loadingTracker.addPromise @tabelaItemService.get(item.id, (data) =>
        @item = data
      )

    @filterAtividades = (atividade) =>
      atividade.id not in @item.atividades if @item?

  testarRegra: (texto = "") ->
    @eflService.test(regra: @item.regraExpressao, itens: texto.split("\n"), (result) =>
      @regraValidacaoTestResult = result
    )

  salvar: (form) ->
    if (form.$valid)
      item = angular.copy @item

      if item.ncms
        item.ncms = item.ncms.collect (ncm) ->
          ncmNumber = parseInt(ncm)
          ncm.toString() if ncmNumber

      if item.ncmExcecoes
        item.ncmExcecoes = item.ncmExcecoes.collect (ncm) ->
          ncmNumber = parseInt(ncm)
          ncm.toString() if ncmNumber

      callback = (retorno) =>
        Alert.success("Item <strong>#{@item.codigo}</strong> da tabela <strong>#{@item.descricaoProduto}</strong> #{if item.id then 'criado' else 'atualizado'} com sucesso.", "Sucesso!")
        @modalInstance.close(new Retorno(true))

      @submitTracker.addPromise(if item.id
          @tabelaItemService.update(item, callback)
        else
          @tabelaItemService.save(item, callback)
      )

angular.module("eficienciaFiscalModule").controller("tabelaItemModalController", TabelaItemModalController)


class TabelaItemImportModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'FileUploader', 'tabela']

  constructor: ($injector, @modalInstance, FileUploader, tabela) ->
    super($injector)

    @uploader = new FileUploader(
      url: '/api/eficiencia-fiscal/tabela-codigo-item.txt'
      headers: cbk.getHeaders()
      formData: [{
        tabela: tabela
      }]
    )

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      @modalInstance.close(new Retorno(true))

  importar: ->
    @uploader.uploadAll()

angular.module("eficienciaFiscalModule").controller('tabelaItemImportModalController', TabelaItemImportModalController)


class TabelaImportarLegislacaoModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'FileUploader', 'tabela']

  constructor: ($injector, @modalInstance, FileUploader, tabela) ->
    super($injector)

    @uploader = new FileUploader(
      url: '/api/eficiencia-fiscal/tabela-codigo-item.csv'
      headers: cbk.getHeaders()
      formData: [{
        tabela: tabela
      }]
    )

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      if response.success
        @modalInstance.close(new Retorno(true))
      else
        switch response.message
          when 'codigos_nao_encontrados'
            Alert.warning('Não foi possível importar todos os itens...', "Os seguintes códigos não foram encontrados no sistema: #{response.data.join(', ')}.", null)

        @modalInstance.close(new Retorno(true))

  importar: ->
    @uploader.uploadAll()

angular.module("eficienciaFiscalModule").controller('tabelaImportarLegislacaoModalController', TabelaImportarLegislacaoModalController)